/**
 * Parses a UTC date string in the format "YYYY-MM-DD HH:mm:ss" to a Date object
 * in UTC regardless of client timezone.
 * @param str string in the format "YYYY-MM-DD HH:mm:ss"
 * @returns The parsed Date object
 */

export function parseUtc(str: string): Date {
  const matcher = str.match(
    /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
  );

  if (!matcher) {
    throw new Error("Invalid format, expected YYYY-MM-DD HH:mm:ss");
  }

  const [, y, mo, d, h, mi, s] = matcher.map(Number);
  return new Date(Date.UTC(y, mo - 1, d, h, mi, s));
}
